module.exports = __webpack_public_path__ + "img/050b_Sitz_thb.83a9d596.jpg";